import { Button } from "@chakra-ui/button"
import { ReactNode } from "react"
import usePageStyling from "src/hooks/usePageStyling"
import useWindowSize from "src/hooks/useWindowSize"
import { isMobileDevice, TWindowSize } from "src/util/browser"

export const PlansButton: React.FC<{
  isMobile: boolean
  isLandscape: boolean
  onClick: any
  buttonText?: string
  disabled?: boolean
  width?: string,
  children?: ReactNode
}> = ({ isMobile, isLandscape, onClick, buttonText, disabled, width, children }) => {
  const plansPageStyles = usePageStyling("plansPageStyling")
  const { screenSize } = useWindowSize()

  return (
    <Button
      width={
        width ??
        (isMobile && isLandscape
          ? "334px"
          : isMobileDevice(screenSize)
          ? "100%"
          : "334px")
      }
      maxW={isMobileDevice(screenSize) && "334px"}
      margin={
        // !showMinifiedLables
        //   ? "0.5rem auto 0px auto !important"
        // :
        "1rem auto 0px auto !important"
      }
      disabled={disabled}
      bg={
        plansPageStyles?.planPageButtonBackgroundColor
          ? plansPageStyles?.planPageButtonBackgroundColor
          : "#1AC541"
      }
      border={
        plansPageStyles?.planPageButtonBorderColor
          ? `1px solid ${
              plansPageStyles?.planPageButtonBorderColor
                ? plansPageStyles.planPageButtonBorderColor
                : "transparent"
            }`
          : "0px"
      }
      textColor={
        plansPageStyles?.planPageButtonTextColor
          ? plansPageStyles?.planPageButtonTextColor
          : "#FFFFFF"
      }
      _hover={{
        backgroundColor: plansPageStyles?.planPageButtonMouseoverBackgroundColor
          ? plansPageStyles.planPageButtonMouseoverBackgroundColor
          : "#24A840",
        textColor: plansPageStyles?.planPageButtonMouseoverTextColor
          ? plansPageStyles.planPageButtonMouseoverTextColor
          : "#FFFFFF",
        borderColor: plansPageStyles?.planPageButtonBorderMouseoverColor ?? null
      }}
      borderRadius={plansPageStyles?.planPageButtonBorderRadius}
      // onClick={handleOnClick}
      onClick={onClick}
      _focus={{}}
      _active={{}}
    >
      {children ?? buttonText}
    </Button>
  )
}
